module.exports = __webpack_public_path__ + "Gotham-Medium.761b2b342675403e254e.eot";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Medium.eot
// module id = ../../../../../src/assets/fonts/Gotham-Medium.eot
// module chunks = 2